import React from "react";
import Quotation from "../../images/TrustedByMany/quotation.svg";
import { IoStar, IoStarOutline } from "react-icons/io5";
import { Container } from "react-bootstrap";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";

const Reviews = ({
  caption = "",
  title = "",
  description,
  testormonials = {},
}) => {
  const showRatings = (ratings) => {
    let unratedRating = 5 - ratings;
    let rated = [];
    let unrated = [];

    while (ratings > 0) {
      rated.push("");
      ratings--;
    }

    while (unratedRating > 0) {
      unrated.push("");
      unratedRating--;
    }

    return (
      <div className={s.ratings}>
        {rated.map((rated, idx) => (
          <span className={s.full_rating} key={idx}>
            <IoStar size="22px" />
          </span>
        ))}
        {unrated.map((rated, idx) => (
          <span className={s.unrated} key={idx}>
            <IoStarOutline size="22px" />
          </span>
        ))}
      </div>
    );
  };

  return (
    <section className={`section-center ${s.reviews}`}>
      <Container>
        <div className={s.header}>
          <h5 className="fw-normal"> {caption} </h5>
          <h1> {title} </h1>
          <h5 className="fw-normal"> {description} </h5>
        </div>
        <div className={s.testimony_grid}>
          {testormonials.map(({ testimony, name, rating }, idx) => {
            return (
              <div className={s.testimony} key={idx}>
                <img loading="lazy" src={Quotation.src} alt="image" />
                <p className={secondaryFont}>{testimony}</p>
                <p className={`${secondaryFont}`}>{name}</p>
                {/* <p className={secondaryFont}>{title}</p> */}
                {showRatings(rating)}
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Reviews;
